import { render } from "./AdminsView.vue?vue&type=template&id=0a6fb116&scoped=true"
import script from "./AdminsView.vue?vue&type=script&lang=js"
export * from "./AdminsView.vue?vue&type=script&lang=js"

import "./AdminsView.vue?vue&type=style&index=0&id=0a6fb116&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6fb116"]])

export default __exports__